/* @ngInject */
export default function IconFormatterService() {
    return {
        chooseParameterIcon: function (parameterName) {
            let parameterIcon = '';
            if (parameterName) {
                /**
                 * Change the parameter name to lowercase, and match on it.
                 * Must return a string, since this will be used for DOM classes.
                 *
                 * One day when we have the ability, these would be good defaults:
                 *
                 * case "electrical parm default":
                 *    parameterIcon = "ion-flash";
                 *    break;
                 * case "dimensional parm default":
                 *    parameterIcon = "ion-arrow-resize";
                 *    break;
                 * case "description parm default":
                 *    parameterIcon = "ion-clipboard";
                 *    break;
                 */
                switch (parameterName.toLowerCase()) {
                    case 'approval other':
                    case 'approvals':
                    case 'brand':
                    case 'construction':
                    case 'cqc':
                    case 'crimp type':
                    case 'csa':
                    case 'cul':
                    case 'drawing':
                    case 'enec':
                    case 'lead':
                    case 'marking':
                    case 'notes':
                    case 'number of pins':
                    case 'number of terminations':
                    case 'reference size':
                    case 'sleeving':
                    case 'step':
                    case 'thread pinch':
                    case 'tree':
                    case 'ul':
                        parameterIcon = 'ion-clipboard';
                        break;
                    case 'aging rate':
                    case 'compare dissipation factor':
                    case 'compare esr/impedance at 100khz':
                    case 'compare inductance':
                    case 'compare leakage':
                    case 'compare ripple current at 120hz':
                    case 'current':
                    case 'dielectric':
                    case 'dielectric strength':
                    case 'dissipation factor':
                    case 'esr':
                    case 'impedance':
                    case 'impedance ratio at -25c':
                    case 'impedance ratio at -40c':
                    case 'impedance ratio at -55c':
                    case 'insulation resistance':
                    case 'max dvdt':
                    case 'quality factor':
                        parameterIcon = 'ion-flash';
                        break;
                    case 'compare life':
                    case 'life':
                    case 'long life':
                        parameterIcon = 'fa fa-hourglass-half';
                        break;
                    case 'aec-q200':
                    case 'automotive':
                    case 'airbag':
                        parameterIcon = 'ion-model-s';
                        break;
                    case 'capacitance' :
                    case 'secondary capacitance':
                    case 'capacitance 2':
                    case 'capacitance tolerance':
                        parameterIcon = 'icon-capacitor-icon';
                        break;
                    case 'case code':
                    case 'chip size':
                    case 'footprint':
                        parameterIcon = 'ion-arrow-expand';
                        break;
                    case 'compare height':
                    case 'compare height max':
                    case 'compare ht ratio':
                    case 'compare thickness':
                    case 'compare pin length':
                    case 'compare termination thickness':
                    case 'compare lead length':
                        parameterIcon = 'fa fa-arrows-v';
                        break;
                    case 'compare length':
                    case 'compare lead spacing':
                    case 'compare lead spacing 2':
                    case 'compare width':
                        parameterIcon = 'fa fa-arrows-h';
                        break;
                    case 'compare diameter':
                    case 'compare lead diameter':
                        parameterIcon = 'fa fa-circle-o';
                        break;
                    case 'compare volume':
                    case 'a':
                    case 'b':
                    case 'c':
                    case 'd':
                    case 'd2':
                    case 'dt':
                    case 'e':
                    case 'f':
                    case 'g':
                    case 'h':
                    case 'h0':
                    case 'j':
                    case 'k':
                    case 'l':
                    case 'l1':
                    case 'l2':
                    case 'll':
                    case 'll negative':
                    case 'll positive':
                    case 'lo':
                    case 'lt':
                    case 'lt1':
                    case 'lt2':
                    case 'lw':
                    case 'mp':
                    case 'p':
                    case 'r':
                    case 's':
                    case 's1':
                    case 't':
                    case 'td':
                    case 'v':
                    case 'w':
                    case 'x':
                    case 'y':
                    case 'z':
                        parameterIcon = 'ion-arrow-resize';
                        break;
                    case 'compare temperature maximum':
                    case 'compare temperature minimum':
                    case 'rated temperature':
                    case 'temperature coefficient':
                    case 'temperature range':
                        parameterIcon = 'ion-thermometer';
                        break;
                    case 'compare packaging':
                    case 'packaging':
                    case 'packaging quantity':
                        parameterIcon = 'fa fa-archive';
                        break;
                    case 'description':
                        parameterIcon = 'ion-clipboard';
                        break;
                    case 'duty cycle':
                        parameterIcon = 'ion-ios-loop';
                        break;
                    case 'failure rate':
                        parameterIcon = 'ion-arrow-graph-down-right';
                        break;
                    case 'inductance':
                        parameterIcon = 'icon-inductor-icon';
                        break;
                    case 'leakage':
                    case 'low leakage':
                    case 'oil filled':
                        parameterIcon = 'ion-paintbucket';
                        break;
                    case 'manufacturer':
                        parameterIcon = 'fa fa-industry';
                        break;
                    case 'miscellaneous':
                    case 'mounting':
                        parameterIcon = 'fa fa-cogs';
                        break;
                    case 'resistance':
                        parameterIcon = 'icon-resistor-icon';
                        break;
                    case 'rohs':
                        parameterIcon = 'ion-leaf';
                        break;
                    case 'safety class':
                    case 'x rating':
                    case 'y rating':
                        parameterIcon = 'ion-alert-circled';
                        break;
                    case 'series':
                        parameterIcon = 'ion-folder';
                        break;
                    case 'style':
                        parameterIcon = 'ion-cube';
                        break;
                    case 'technology':
                        parameterIcon = 'ion-erlenmeyer-flask';
                        break;
                    case 'termination':
                        parameterIcon = 'ion-wrench';
                        break;
                    case 'testing and reliability':
                        parameterIcon = 'fa fa-shield';
                        break;
                    case 'type':
                        parameterIcon = 'ion-grid';
                        break;
                    case 'voltage ac':
                    case 'voltage dc':
                    case 'compare voltage ac':
                    case 'compare voltage dc':
                        parameterIcon = 'fa fa-bolt';
                        break;
                    case 'weight':
                        parameterIcon = 'fa fa-balance-scale';
                        break;
                    case 'features':
                    case 'ac adapter':
                    case 'ballast':
                    case 'bipolar':
                    case 'extended capacitance':
                    case 'face down terminals':
                    case 'flat pack':
                    case 'gto':
                    case 'halogen free':
                    case 'industrial grade':
                    case 'inverter':
                    case 'multi-anode':
                    case 'polar':
                    case 'rectangular anode':
                    case 'soldering star':
                    case 'time constant circuit':
                    case 'vibration resistant':
                        parameterIcon = 'ion-ios-pricetags';
                        break;
                    case '150c':
                    case '175c':
                        parameterIcon = 'ion-thermometer';
                        break;
                    case 'audio':
                        parameterIcon = 'ion-headphone';
                        break;
                    case 'high current':
                    case 'high cv':
                    case 'high frequency':
                    case 'high ripple':
                    case 'high voltage':
                        parameterIcon = 'ion-arrow-graph-up-right';
                        break;
                    case 'high temperature':
                    case 'high temperature solder':
                        parameterIcon = 'ion-thermometer';
                        break;
                    case 'low df':
                    case 'low esr':
                    case 'low impedance':
                    case 'low profile':
                    case 'low profile 5mm':
                    case 'low profile 6mm':
                    case 'low profile 7mm':
                    case 'rapid discharge':
                        parameterIcon = 'ion-arrow-graph-down-right';
                        break;
                    case 'micro miniature':
                    case 'miniature':
                    case 'reduced size':
                    case 'substrate':
                        parameterIcon = 'ion-arrow-shrink';
                        break;
                    case 'photo flash':
                        parameterIcon = 'ion-camera';
                        break;
                    default:
                        parameterIcon = 'fa fa-info-circle';
                }
            } else {
                parameterIcon = 'undefined';
            }

            return parameterIcon;
        },
    };
}
